/**
 * Preview App Component
 * 
 * Main component for the notification bar preview
 * 
 * @package TopBuddy
 */

import { useEffect } from '@wordpress/element';
import { useDispatch } from '@wordpress/data';
import NotificationBarPreview from './components/NotificationBarPreview';
import '../store';

const App = () => {
	const { setActiveComponents, setAvailableComponents } = useDispatch('topbuddy/components');
	const { setSettings } = useDispatch('topbuddy/settings');
	
	// Initialize store with data from PHP on mount
	useEffect(() => {
		const previewData = window.topbuddyPreview || {};
		const postSettingsData = window.topbuddyPostSettings || {};
		
		if (previewData.initialComponents) {
			setActiveComponents(previewData.initialComponents);
		}
		
		if (previewData.availableComponents) {
			setAvailableComponents(previewData.availableComponents);
		}

		// Initialize settings from post settings data
		if (postSettingsData.initialSettings) {
			setSettings(postSettingsData.initialSettings);
		}
	}, [setActiveComponents, setAvailableComponents, setSettings]);
	
	return <NotificationBarPreview />;
};

export default App;
